<template>
  <div class="event-chart">
    <div class="event-info">
      <div class="event-name">{{eventItem.eventName}}</div>
      <div class="event-date">{{eventItem.prefDate}}</div>
    </div>
    <EventBarChart :labels="chartData.labels" :data="chartData.data" :width="254" :height="200"></EventBarChart>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EventBarChart from './event-bar-chart';

  export default {
    name: 'event-bar-chart',
    components: {
      EventBarChart
    },
    data () {
      return {
        chartData: {
          labels: [],
          data: []
        },
        chartItemNumber: 0
      }
    },
    props: {
      eventItem: {
        type: Object,
        default: {}
      },
      reportType: {
        type: String,
        default: 'upcoming'
      }
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({
        actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
      })
    },
    mounted () {
      this.actionGetEventReportChart({eventId: this.eventItem.id, reportType: this.reportType}).then(response => {
        // Todo remove dummy data after finish
        if (this.chartData.labels.length === 0) {
          this.chartData.labels = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
          /* this.chartData.labels = ['Overall', 'Professionalism', 'Willingness to Recommend', 'Communication', 'Preparedness', 'On-Time Start and Finish', 'Check-in Process', 'Professionalism - Coach', ' Professionalism - Screener', 'Professionalism - Lead', 'Scheduler Tool', 'Reporting', 'Participant Feedback', 'Data Transfer', 'Event Breakdown']; */
        }
        if (this.chartData.data.length === 0) {
          this.chartData.data = [4, 3, 5, 3, 3, 3, 3.5, 4.5, 2.5, 2, 1, 3.7, 4.6, 2.8, 5];
        }
      });
    }
  };
</script>

<style lang="less" scoped="">
  .event-chart {
    padding: 12px 0 12px 16px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 1px rgba(0, 0, 0, 0.1);
    height: 300px;
    width: 270px;
    float: left;
    margin-right: 24px;
    margin-bottom: 26px;
    .event-name {
      height: 24px;
      color: #00A4D6;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .event-date {
      height: 16px;
      color: #8E8E8E;
      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      letter-spacing: 0.1px;
      line-height: 16px;
    }

    .chart-data-type {
      height: 24px;
      color: #8E8E8E;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 24px;
      text-align: right;
      position: absolute;
      top: 0;
      right: 8px;
    }

    .event-info {
      position: relative;
      margin-bottom: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// EventBarChart.vue?df048f6e